// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// console.log('===='+process.env.VUE_APP_TITLE);
import "mdbvue/build/css/mdb.css";
import "bootstrap-datepicker";

import "bootstrap-timepicker";
import Vue from "vue";
import App from "./App";
import router from "./router";
import Toasted from "vue-toasted";
import ScrollLoader from "vue-scroll-loader";
import VueLodash from "vue-lodash";
import moment from "moment";
import VueSweetalert from "vue-sweetalert2";
import VueClipboard from "vue-clipboard2";
import VueAwesomeSwiper from "vue-awesome-swiper";

// import style
import "swiper/css/swiper.css";
Vue.use(VueAwesomeSwiper, {});
Vue.use(VueClipboard);
Vue.use(VueLodash);
Vue.use(ScrollLoader);
Vue.filter("tomorrowDayName", function(value) {
  if (value) {
    return moment(String(value)).format("ddd");
  }
});

Vue.filter("formatDateOnly", function(value) {
  if (value) {
    return moment(String(value)).format("MMM Do");
  }
});
Vue.filter("formatHour", function(value) {
  if (value) {
    let momentObj = moment(value, ["h:mm"]);
    return momentObj.format("h:mm a");
  }
});

Vue.filter("formatDateTime", function(value) {
  if (value) {
    return moment(String(value)).format("D MMM  hh:mm A");
  }
});
Vue.filter("findNumberOfDays", function(value) {
  if (value) {
    let today = moment(new Date());
    let getDate = moment(value).format("YYYY-MM-DD");
    let dateDiff = today.diff(getDate, "days");
    if (dateDiff === 0) {
      return "Today";
    } else if (dateDiff === 1) {
      return dateDiff + " Day ago";
    } else if (dateDiff > 1) {
      return dateDiff + " Days ago";
    }
  }
});

Vue.filter("formatDateWithoutTime", function(value) {
  if (value) {
    return moment(String(value)).format("LL");
  }
});
Vue.config.productionTip = false;
//global variable
Vue.mixin({
  data() {
    return {
      get globalLanguage() {
        let language = localStorage.getItem("language");
        if (language === null || language == "") {
          return "BN";
        }
        return language;
      },
      get globalUrl() {
        return "https://shop.shahpremiumfoods.com/api/";
      },
      get loginStatus() {
        if (localStorage.getItem("logged_in_user_name")) {
          return true;
        }
        return false;
      },

      get fileUrl() {
        return "https://shop.shahpremiumfoods.com/";
      }
    };
  },
  methods: {
    getWishlist() {
      let list = JSON.parse(localStorage.getItem("wishlist"));
      return list === null ? [] : list;
    },
    isInWishlist(productId) {
      return this.getWishlist().findIndex(x => x.id === productId) >= 0;
    },
    toggleWishlist(product) {
      let list = this.getWishlist();
      let idx = list.findIndex(x => x.id === product.id);
      if (idx >= 0) {
        list.splice(idx, 1);
        localStorage.setItem("wishlist", JSON.stringify(list));
        this.$toasted.show("Removed from Wishlist.", {
          type: "info",
          icon: "fa-heart-o",
          position: "bottom-left"
        });
      } else {
        list.unshift(product);
        localStorage.setItem("wishlist", JSON.stringify(list));
        this.$toasted.show("Added to Wishlist.", {
          type: "success",
          icon: "fa-heart",
          position: "bottom-left"
        });
      }
      window.dispatchEvent(new Event("wishlist-updated"));
    }
  }
});

const options = {
  confirmButtonColor: "#41b882",
  cancelButtonColor: "#ff7674"
};

Vue.use(VueSweetalert, options);
Vue.use(Toasted, {
  theme: "bubble",
  //theme: "toasted-primary",
  position: "top-right",
  iconPack: "fontawesome",
  //closeHtml: "check",
  closeOnSwipe: true,
  fitToScreen: true,
  fullWidth: false,
  showCloseButton: true,
  duration: 10000
});
// ['top-right', 'top-center', 'top-left', 'bottom-right', 'bottom-center', 'bottom-left']
// Type of the Toast ['success', 'info', 'error']
// ['toasted-primary', 'outline', 'bubble']
/* eslint-disable no-new */

//check  login
router.beforeEach((to, from, next) => {

  if (
    to.path == "/myorders" ||
    to.path == "/my-profile" ||
    to.path == "/marketer-sells" ||
    to.path == "/my-deposit" ||
    to.path == "/deposit-history"
  ) {
    let token = localStorage.getItem("token");
    if (Vue._.isEmpty(token)) {
      return next("/");
    }
  }
  next();
});
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
  created() {
    this.globalUrl = "This won't change it";
  }
});
